import React from 'react';
import { OrderFormProps } from './OrderFormModel';
import { FormikProps } from 'formik';
import i18n from 'i18next';
import styles from './orderForm.module.scss';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { notRoles } from 'core/permission/PermissionDSL';
import { RoleNames } from 'core';
import { Order } from 'core/order/Order';
import { FormikField } from 'components/form/field/FormikField';
import { CustomField } from 'components/form/field/CustomField';

export class EditOrderFormContent extends React.Component<
  OrderFormProps & { formik: FormikProps<Order> },
  any
> {
  originBudget: number;

  constructor(props) {
    super(props);
    if (this.props.model.formikProps) {
      this.originBudget = this.props.model.formikProps.values.budget;
    } else {
      this.originBudget = 0;
    }
  }

  componentDidMount() {
    this.props.model.setNeedCheckModifyReason(this.getShowModifyReasonValue());
  }

  componentDidUpdate() {
    this.props.model.setNeedCheckModifyReason(this.getShowModifyReasonValue());
  }

  onEditBudgetClick = () => {
    const model = this.props.model;
    if (model.state.showBudgetInputField && model.formikProps) {
      model.formikProps.setValues(
        (prev) => ({
          ...prev,
          budget: this.originBudget,
          modifyReason: undefined,
        }),
        true,
      );
    }
    model.triggerBudgetInputField && model.triggerBudgetInputField();
  };

  getShowModifyReasonValue = () => {
    const model = this.props.model;
    const order = model.formikProps && model.formikProps.values;
    if (order) {
      return (
        order.modifyReason !== undefined || model.state.showBudgetInputField
      );
    }
    return false;
  };

  renderBudgetField = () => {
    const model = this.props.model;
    const currency = model.localeMeta ? model.localeMeta.currency : 'NTD';

    const renderField = () =>
      model.state.showBudgetInputField ? (
        <FormikField.InputGroup
          prefix={currency}
          name='budget'
          type='number'
          formGroupClassName={styles.orderBudgetWithButton}
          postComponent={
            <Button
              style={{ width: 'max-content' }}
              variant='secondary'
              size='sm'
              onClick={this.onEditBudgetClick}
            >
              {i18n.t<string>('orderForm.labels.modifyCancel')}
            </Button>
          }
        />
      ) : (
        <FormikField.InputGroup
          as='label'
          prefix={currency}
          prefixBorder={false}
          name='budget'
          fieldContentWidth={'max-content'}
          className={styles.budgetLabel}
          formGroupClassName={styles.orderBudgetWithButton}
          postComponent={
            <Button
              style={{ width: 'max-content' }}
              variant='secondary'
              size='sm'
              onClick={this.onEditBudgetClick}
            >
              {i18n.t<string>('orderForm.labels.modifyBudget')}
            </Button>
          }
        />
      );

    if (model.showEditButton) {
      return (
        <CustomField
          label={i18n.t<string>('orderForm.labels.budget')}
          render={renderField}
        />
      );
    }

    return (
      <FormikField.InputGroup
        formGroupClassName={styles.budget}
        label={i18n.t<string>('orderForm.labels.budget')}
        name='budget'
        prefix={currency}
        type='number'
      />
    );
  };

  render() {
    const order =
      this.props.model.formikProps && this.props.model.formikProps.values;
    if (!order) {
      return <div />;
    }

    return (
      <div className={styles.editOrderForm}>
        <PermissionChecker
          permissionAware={notRoles(
            RoleNames.adsAdmin,
            RoleNames.adsSales,
            RoleNames.adsReport,
          )}
        >
          <FormikField.Label
            label={i18n.t<string>('orderForm.labels.advertiser')}
            name='advertiserName'
          />
        </PermissionChecker>
        <FormikField.Input
          label={i18n.t<string>('orderForm.labels.name')}
          name='projectName'
        />
        <FormikField.DateRangePicker
          name='dateRange'
          label={i18n.t<string>('orderForm.labels.dateRange')}
          className={styles.dateRange}
          minDate={this.props.model.dateRangeMinDate}
          maxDate={moment(this.props.model.dateRangeMinDate)
            .add(10, 'years')
            .format('YYYY-MM-DD')}
          startDateFormikName='startDate'
          endDateFormikName='endDate'
          format={'YYYY-MM-DD'}
          showTimePicker={false}
          startDatePickerDisabled={this.props.model.isOrderStarted}
          hint={i18n.t<string>('orderForm.labels.totaldates', {
            num: this.props.model.totalDays,
          })}
          hoverHint={i18n.t<string>('orderForm.labels.dateCannotModifyHint')}
        />
        {this.renderBudgetField()}
        {this.getShowModifyReasonValue() && (
          <FormikField.TextArea
            label={i18n.t<string>('orderForm.labels.modifyReason')}
            name='modifyReason'
          />
        )}
        <FormikField.TextArea
          label={i18n.t<string>('orderForm.labels.remark')}
          name='comments'
        />
      </div>
    );
  }
}
